module.exports = __webpack_public_path__ + "static/media/refund.850a4688.svg";